import { Component, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastService } from "angular-toastify";
import { isNil } from "lodash-es";
import { ApiService } from "src/app/api/api.service";
import { FormularioNominarComponent } from "src/app/componentes/formulario-nominar/formulario-nominar.component";
import { CoreService } from "src/app/services/core-service/core-service.service";
import { Result, parseError } from "src/app/shared/interfaces";
import Swal from "sweetalert2";

@Component({
    selector: 'nominar',
    templateUrl: './nominar.component.html',
    styleUrl: './nominar.component.scss'
})
export class NominarComponent {

    @ViewChild(FormularioNominarComponent) formularioComp: FormularioNominarComponent | any = null;

    formulario = new FormGroup({
        id: new FormControl(),
        imagen: new FormControl(null, { validators: [Validators.required] }),
        nombre: new FormControl('', { validators: [Validators.required] }),
        apellido: new FormControl('', { validators: [Validators.required] }),
        departamento: new FormControl('Guatemala', { validators: [Validators.required] }),
        categoria_id: new FormControl(0, Validators.required),
        categoria: this.fb.group({
            id: new FormControl(null),
            nombre: new FormControl(''),
            imagen: new FormControl()
        }),
        descripcion: new FormControl('', Validators.required),
        descripcion_corta: new FormControl('', Validators.required),
        descripcion_larga: new FormControl('', Validators.required),
        votos: new FormControl(null),
        profesion: new FormControl('', Validators.required),
        periodo_id: new FormControl(1, Validators.required),
        estado_id: new FormControl(null),
        RedSocialPerfil: this.fb.array([
            this.fb.group({
                perfil_id: new FormControl(null),
                link: new FormControl(null, Validators.required),
                red_social_id: new FormControl(1),
                redSocial: new FormControl('Facebook') //Facebook
            }),
            this.fb.group({
                perfil_id: new FormControl(null),
                link: new FormControl(null, Validators.required),
                red_social_id: new FormControl(2),
                redSocial: new FormControl('LinkedIn') //LinkedIn
            }),
            this.fb.group({
                perfil_id: new FormControl(null),
                link: new FormControl(null, Validators.required),
                red_social_id: new FormControl(3),
                redSocial: new FormControl('Instagram') //Instagram
            }),
            this.fb.group({
                perfil_id: new FormControl(null),
                link: new FormControl(null, Validators.required),
                red_social_id: new FormControl(4),
                redSocial: new FormControl('Twitter') //Twitter
            })
        ]),
        LogrosPerfil: this.fb.array([
            this.fb.group({
                id: null,
                perfilId: null,
                logro: new FormControl('', Validators.required),
                holder: 'Ejemplo: Generó trabajo para 120 familias en Alta Verapaz durante el año 2018.'
            }),
            this.fb.group({
                id: null,
                perfilId: null,
                logro: new FormControl('', Validators.required),
                holder: 'Ejemplo: Exposición en 5 países de Suramérica durante la Bienal X en el 2018.'
            }),
            this.fb.group({
                id: null,
                perfilId: null,
                logro: new FormControl('', Validators.required),
                holder: 'Ejemplo: Premio en Ciencia y Tecnología en la ciudad de México en 1995.'
            })
        ]),
        desarrollo_carrera: new FormControl(null, Validators.required),
        personas_beneficiadas: new FormControl(null, Validators.required),
        grupo_politico_religioso: new FormControl(null, Validators.required),
        correo: new FormControl(null, Validators.required),
        telefono: new FormControl(null, Validators.required),
        created_at: new FormControl(),
        updated_at: new FormControl(),
        correo_solicitante: new FormControl(null, Validators.required),
        nombre_solicitante: new FormControl(null, Validators.required),
        telefono_solicitante: new FormControl(null, Validators.required),
        aceptar_terminos: new FormControl(null, Validators.required)
    });

    private _step = 1;

    constructor(
        private fb: FormBuilder,
        private core: CoreService,
        private ntf: ToastService,
        private api: ApiService,
        private router: Router
    ) {

    }

    regresar() {
        this._step -= 1;
    }

    siguiente() {
        this._step += 1;
    }

    async finalizar() {
        try {
            this.core.lock()
        } catch (e) {
            this.ntf.error(`No se pudo general el perfil: ${parseError(e)}`)
        } finally {
            this.core.unlock()
        }
    }

    async nominar() {
        try {
            this.core.lock()
            const success = await this.formularioComp.uploadImage();
            if(!success){
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "No se pudo subir la imagen, puedes cambiar la imagen para poder crear la nominación.",
                    showConfirmButton: false,
                    timer: 5000
                });
                return;
            }
            await this.api.consulta('nominar', false, [], this.formulario.getRawValue(), 'POST')
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Se realizó la nominación.",
                showConfirmButton: false,
                timer: 1500
            });
            this.router.navigate(['/'])
        } catch (e) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: `Error: ${parseError(e)}`,
                showConfirmButton: false,
                timer: 1500
            });
        } finally {
            this.core.unlock()
        }
    }

    camposValidos() {
        let stepValido = true;
        switch (this._step) {
            case 1:
                if (!this.formulario.controls.nombre.valid || !this.formulario.controls.apellido.valid || !this.formulario.controls.departamento.valid || !this.formulario.controls.profesion.valid || !this.formulario.controls.imagen.valid) {
                    stepValido = false;
                }
                break;
            case 2:
                if (!this.formulario.controls.categoria_id.valid || !this.formulario.controls.descripcion_larga.valid || !this.formulario.controls.LogrosPerfil.valid || !this.formulario.controls.desarrollo_carrera.valid || !this.formulario.controls.grupo_politico_religioso.valid) {
                    stepValido = false;
                }
                break;
            case 3:
                if (!this.formulario.controls.correo.valid || !this.formulario.controls.telefono.valid) {
                    stepValido = false;
                }
                break;
            case 4:
                if (!this.formulario.controls.nombre_solicitante.valid || !this.formulario.controls.correo_solicitante.valid || !this.formulario.controls.aceptar_terminos.valid) {
                    stepValido = false;
                }
                break;
            default:
                break;
        }
        return stepValido;
    }

    get step(): number {
        return this._step;
    }
}